import { getPmStatuses } from 'common/services/pm.service';
import { useEffect, useState } from 'react';
import _ from 'lodash';

const usePmStatuses = () => {
  const [data, setData] = useState([]);

  const fetchStatuses = async () => {
    try {
      const statuses = await getPmStatuses();
      const uniqStatuses = _.uniqBy(statuses.items || [], 'value');
      setData(uniqStatuses);
    } catch (e) {}
  };

  useEffect(() => {
    fetchStatuses();
  }, []);

  return data;
};

export default usePmStatuses;
